import React, { HTMLAttributes } from 'react';
import { classCombine } from 'tradevan-ui/consts';

const TableTit = (props: HTMLAttributes<HTMLHeadingElement>) => {
  const { children, className, ...other } = props;

  return (
    <h2 className={classCombine('table-tit', className)} {...other}>
      {children}
    </h2>
  );
};

export default TableTit;
